module.exports = __webpack_public_path__ + "static/media/smallLogo.5bb60b38.png";